import {ROOT_URL, FETCH_ALL_FORMS, CREATE_FORM, GET_FORM} from '../../constants';
import axios from 'axios';

export const fetchForms = (id) => {
  const url = `${ROOT_URL}/forms?studentId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then(response => {
        dispatch({
          type: FETCH_ALL_FORMS,
          forms: response.data
        })
      })
      .catch(err => console.log(err))
  }
};

export const getFormById = (formId) => {
  const url =`${ROOT_URL}/forms/${formId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then(response => {
        dispatch({
          type: GET_FORM,
          form: response.data
        })
      })
      .catch(err => console.log(err))
  }
};

export const createForm = (id, form) => {
  const url = `${ROOT_URL}/forms?studentId=${id}`;
  return (dispatch) => {
    axios
      .post(url, {...form, type: 'Plan'})
      .then(response => {
        dispatch({
          type: CREATE_FORM,
          form: response.data
        })
      })
      .catch(err => console.log(err))
  }
};

export const activateForm = (id) => {
  const url = `${ROOT_URL}/forms/${id}/advance-state`;
  return (dispatch) => {
    axios
      .post(url)
      .then(response => {
        dispatch({
          type: CREATE_FORM,
          form: response.data
        });
      })
      .catch(err => console.log(err))
  }
};